// Selectors
export const getInsights = (state, eventId) => state.insights.insights[eventId];

export const getInsightsLoading = (state, eventId) => state.insights.loading[eventId];

export const getInsightsError = (state, eventId) => {
  return state.insights?.errors?.[eventId] || null;
};

/**
 * Get the current processing stage for an event's insights
 * @param {Object} state - Redux state
 * @param {string} eventId - Event ID
 * @returns {string|null} The current processing stage
 */
export const getInsightsProcessingStage = (state, eventId) => {
  return state.insights?.processingStage?.[eventId] || null;
};